export default __webpack_public_path__ + "static/media/wa-1718-1.77b77e76.jpg";